import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';


const VirtualTourCard = ({ tour, onStart }) => {
  return (
    <div className="bg-[var(--color-card)] rounded-lg overflow-hidden shadow-conservation hover:shadow-conservation-lg animation-organic group border border-[var(--color-border)]">
      <div className="relative h-56 overflow-hidden">
        <Image
          src={tour?.thumbnail}
          alt={tour?.thumbnailAlt}
          className="w-full h-full object-cover group-hover:scale-105 animation-organic"
        />
        <div className="absolute top-3 left-3 bg-[var(--color-primary)] text-white px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1">
          <Icon name="Play" size={14} />
          {tour?.duration}
        </div>
      </div>
      <div className="p-5">
        <h3 className="text-lg font-semibold text-[var(--color-foreground)] mb-2 group-hover:text-[var(--color-primary)] transition-colors">
          {tour?.title}
        </h3>
        <p className="text-sm text-[var(--color-muted-foreground)] mb-4 line-clamp-2">{tour?.description}</p>
        
        <div className="flex items-center justify-between text-sm text-[var(--color-muted-foreground)] mb-4">
          <div className="flex items-center gap-1">
            <Icon name="MapPin" size={16} />
            <span>{tour?.locations} locations</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="Eye" size={16} />
            <span>{tour?.views} views</span>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-4">
          {tour?.highlights?.map((highlight, index) => (
            <span key={index} className="px-2 py-1 bg-[var(--color-accent)]/20 text-[var(--color-accent)] text-xs rounded-full">
              {highlight}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VirtualTourCard;